import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, accountShape, checkedOutItemShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import SelectionCard from '@bibliocommons/selection-card';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';
import { ModalHeader, ModalContent, ModalFooter } from '@bibliocommons/modal';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';

import './DownloadForm.scss';

export default class DownloadForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formatSelected: null
    };
    bindAll(this);
  }

  componentDidMount() {
    const { bib, digitalFormats, bibsActions } = this.props;
    if (!digitalFormats) {
      bibsActions.fetchDigitalFormats({ metadataId: bib.get('id') });
    }
  }

  handleFormatChange(name) {
    const { digitalFormats } = this.props;
    const selectedFormat = digitalFormats.find(format => format.get('name') === name);

    this.setState({
      formatSelected: selectedFormat.get('name')
    });
  }

  handleFormatLockIn() {
    const { formatSelected } = this.state;
    const { currentAccount, bib, checkoutActions, checkoutItem, handleClose } = this.props;

    if (formatSelected) {
      checkoutActions.lockInFormat({
        accountId: currentAccount.get('id'),
        checkoutId: checkoutItem.get('checkoutId'),
        format: formatSelected,
        metadataId: bib.get('id'),
        postSuccess: handleClose,
        title: bib.getIn(['briefInfo', 'title'])
      });
    }
  }

  renderFormatSelectionCard() {
    const { digitalFormats } = this.props;

    return digitalFormats.map(format => {
      const formatName = format.get('name');
      if (format.get('hasDownloadLink')) {
        return (
          <SelectionCard
            selected={formatName === this.state.formatSelected}
            value={formatName}
            label={<FormattedMessage id={`digiformat_${formatName.toLowerCase()}`} />}
            name="format"
            handleClick={this.handleFormatChange}
            key={formatName}
          />
        );
      }
      return null;
    });
  }

  renderFormatSelector() {
    const { digitalFormats, isLoading } = this.props;

    if (digitalFormats && digitalFormats.size) {
      return (
        <div className="format-selector">
          <div className="format-selection-heading">
            <FormattedMessage id="select_a_format" />
          </div>
          <div className="format-selection-cards">{this.renderFormatSelectionCard()}</div>
        </div>
      );
    }

    return (
      <div className="format-selector">
        <em className="loading-indicator">
          {isLoading ? <FormattedMessage id="loading_formats" /> : <FormattedMessage id="errors.DigitalFormats" />}
          <span aria-hidden>&hellip;</span>
        </em>
      </div>
    );
  }

  render() {
    const { bib, checkoutTransactions } = this.props;

    return (
      <div className="cp-download-form">
        <ModalHeader title={<FormattedMessage id="download" />} />
        <ModalContent>
          <BibBriefContainer metadataId={bib.get('id')} />
          {this.renderFormatSelector()}
        </ModalContent>
        <ModalFooter
          primaryActionButtonTag={TransactionalSolidButton}
          primaryActionButtonText={<FormattedMessage id="download" />}
          disabled={!this.state.formatSelected}
          isLoading={checkoutTransactions.getIn([bib.get('id'), 'isLockingFormat'])}
          handlePrimaryAction={this.handleFormatLockIn}
        />
      </div>
    );
  }
}

DownloadForm.propTypes = {
  bib: bibShape.isRequired,
  handleClose: PropTypes.func.isRequired,
  currentAccount: accountShape.isRequired,
  checkoutItem: checkedOutItemShape.isRequired,
  isLoading: PropTypes.bool.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  checkoutActions: PropTypes.objectOf(PropTypes.func).isRequired,
  checkoutTransactions: ImmutablePropTypes.map.isRequired,
  digitalFormats: ImmutablePropTypes.list.isRequired
};
